import { render, staticRenderFns } from "./ContactCreationSlider.vue?vue&type=template&id=b2b879e6&"
import script from "./ContactCreationSlider.vue?vue&type=script&lang=ts&"
export * from "./ContactCreationSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCreationSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports